import React from 'react';
import packageJson from '../../package.json';

export default function Version() {
  const version = packageJson.version;
  return (
    <div 
      className="app-version-badge"
      style={{
        position: 'fixed',
        bottom: '8px',
        right: '12px',
        fontSize: '0.68rem',
        fontWeight: 500,
        color: '#94a3b8',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(4px)',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        padding: '2px 8px',
        borderRadius: '9999px',
        pointerEvents: 'none',
        zIndex: 50
      }}
    >
      v{version}
    </div>
  );
}